import React from 'react';

import * as Recharts from 'recharts';

import { Grid, LegacyText, styled } from '@gogame/components';
import { DateRangeFormatter } from '@gogame/intl-ts';

const LineLabel = styled(
  React.forwardRef(({ dashed: _, ...props }, ref) => {
    return <span {...props} ref={ref} />;
  })
)`
  height: 0;
  border: 0;
  border-color: ${(props) => props.theme.palette.action.disabled};
  border-top-width: 2px;
  border-style: ${(props) => (props.dashed ? 'dashed' : 'solid')};
  width: 14px;
  display: flex;
`;

const renderLegend = ({ dateRanges }) => {
  return (
    <Grid container spacing={2} alignItems={'center'} justifyContent={'center'}>
      {dateRanges.map((rage, i) => {
        return (
          <Grid
            item
            container
            spacing={1}
            key={i}
            alignItems={'center'}
            style={{ width: 'auto', flexGrow: 'initial' }}
          >
            <Grid item>
              <LineLabel dashed={!!i} />
            </Grid>
            <Grid item>
              <LegacyText size={'10px'}>
                <DateRangeFormatter value={rage} template={'LL'} />
              </LegacyText>
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default class DateRangeLegend extends Recharts.Legend {
  static defaultProps = {
    ...Recharts.Legend.defaultProps,
    content: renderLegend,
  };
}
// DOESN'T WORK

// export default ({ content = renderLegend, ...props }) => {
//   console.log('Recharts, Legend',Recharts.Legend , content, props);
//
//   return <Recharts.Legend content={content} {...props} />;
// };
